import React, {createContext, useContext, useReducer} from 'react'
import {PrinterDeviceOverviewReducer} from "../reducer/PrinterDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const PrinterDeviceOverviewContext = createContext();

const PrinterDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        asmlComponentInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(PrinterDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <PrinterDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </PrinterDeviceOverviewContext.Provider>
    )
}

export default PrinterDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/context/PrinterDeviceOverviewContext.js